const API_BASE_URL = 'https://4vkpvv0re3.execute-api.ap-southeast-2.amazonaws.com/v1';

class TestReportAPI {
  constructor() {
    this.baseUrl = `${API_BASE_URL}/test-report`;
  }

  // 获取认证头
  getAuthHeaders(idToken) {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };
  }
  // 生成所有responses的报告（基于template ID，可选择特定group或includeAllGroups）
  // batchId: 指定考试批次时，报告内的排名/分布只用该批次的学生（预测分数仍用全量历史数据）
  async generateAllResponsesReport(templateId, idToken, group = null, includeAllGroups = false, transformationMethod = null, batchId = null) {
    try {
      const requestData = {
        templateId
      };

      // 如果提供了group参数，则添加到请求数据中
      if (group) {
        requestData.group = group;
      }

      // 如果设置了includeAllGroups参数，则添加到请求数据中
      if (includeAllGroups) {
        requestData.includeAllGroups = true;
      }

      // 如果提供了transformationMethod参数，则添加到请求数据中
      if (transformationMethod) {
        requestData.transformationMethod = transformationMethod;
      }

      // 指定考试批次
      if (batchId) {
        requestData.batchId = batchId;
      }

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'generate-all',
          data: requestData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error generating all responses report:', error);
      throw error;
    }
  }

  // 生成单个response的报告
  async generateSingleResponseReport(templateId, responseId, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'generate-single',
          data: {
            templateId,
            responseId
          }
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error generating single response report:', error);
      throw error;
    }
  }

  // 获取完整排名（内部查看用，不生成PDF；家长报告只显示前10名）
  // batchId: 指定考试批次时只对该批次的学生排名
  async getRankings(templateId, idToken, batchId = null) {
    try {
      const data = { templateId };
      if (batchId) {
        data.batchId = batchId;
      }
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'get-rankings',
          data
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error fetching rankings:', error);
      throw error;
    }
  }

  // 生成数据导出（仅限localhost环境）
  async generateDataOnly(templateId, idToken, group = null) {
    try {
      const requestData = {
        templateId
      };
      
      // 如果提供了group参数，则添加到请求数据中
      if (group) {
        requestData.group = group;
      }

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'generate-data-only',
          data: requestData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error generating data export:', error);
      throw error;
    }
  }
}

export const testReportAPI = new TestReportAPI();
